import { arrayOf, bool, number, oneOfType, shape, string } from 'prop-types';

export default class Helpers {
  static fetchKeyword = (sValue, nttParam) => {
    const nttValue = nttParam ? nttParam.replace('Ntt-', '') : '';
    return sValue || nttValue;
  };

  static setCookie = (name, value, days) => {

    if (typeof document === 'undefined') {
      return;
    }
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    const encodedValue = encodeURIComponent(value);
    if (document && document.location && encodedValue) {
      const { hostname = 'www.homedepot.com' } = document.location;
      const host = hostname.replace('www.', '');
      document.cookie = `${name}=${encodedValue}${expires};domain=${host};path=/`;
    }
  };

  static getCookie = (name) => {
    const nameEQ = name + '=';
    const cookieArray = document.cookie.split(';');
    for (let cookie = 0; cookie < cookieArray.length; cookie += 1) {
      let c = cookieArray[cookie];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };
  static isSearchPage = ({ pageType = '', nttParam = '' }) => {
    return pageType === 's' || (pageType === 'b' && nttParam);
  }

  static skuShape = shape({
    productId: string.isRequired,
    itemId: string.isRequired,
    canonicalURL: string,
    productUrl: string,
    availabilityType: string,
    info: Helpers.infoShape,
    storeSku: Helpers.storeSkuShape,
    shipping: shape({
      eligibleForFreeShipping: bool,
      itemLevelFreeShip: bool,
      freeShippingThreshold: string,
      freeShippingMessage: string
    }),
    ratingsReviews: shape({
      averageRating: oneOfType([
        number,
        string
      ]),
      totalReviews: string
    }),
  });

  static infoShape = shape({
    brandName: string,
    productLabel: string.isRequired,
    modelNumber: string,
    productType: string,
    imageId: string,
    totalNumberOfOptions: number,
    minPriceRange: number,
    maxPriceRange: number,
    wasMinPriceRange: number,
    wasMaxPriceRange: number,
    sskSavePercent: number,
    collectionName: string,
    collectionURL: string,
    savingsCenter: string,
    isGenericProduct: bool,
    departmentName: string,
    departmentId: number,
    imageUrl: string.isRequired,
    swatches: arrayOf(shape({})),
    variants: arrayOf(shape({})),
    assetCount: string,
    collectionType: string
  });

  static storeSkuShape = shape({
    fulfillmentOptions: shape({
      fulfillable: bool,
      shipToHome: {
        eligibilityStatus: bool
      },
      storeInventory: string,
      storeStatus: number,
      backOrder: bool
    }),
    pricing: shape({
      uom: string,
      unitsPerCase: string,
      originalPrice: number,
      specialPrice: number,
      alternatePriceDisplay: bool,
      lowerPrice: bool,
      dollarOff: number,
      percentageOff: number
    })
  });

  static skuDefaults = {
    info: {
      swatches: [],
      variants: []
    },
    storeSku: {
      fulfillmentOptions: {},
      pricing: {
        uom: 'each',
        unitsPerCase: '0.0',
        originalPrice: 0,
        specialPrice: 0,
        dollarOff: 0,
        percentageOff: 0,
        alternatePriceDisplay: false,
        lowerPrice: false
      }
    },
    ratingsReviews: {
      averageRating: '0',
      totalReviews: '0'
    }
  };

  static pushWrapper = ({ event, url, push, callback, keyEvent = {} }) => {
    // cmd / ctrl clicks should open in new tabs.
    // Cmd: Firefox: 224
    // Opera: 17
    // WebKit browsers (Safari/Chrome): 91 (Left Command) or 93 (Right Command)
    // No Destructure: See - https://reactjs.org/docs/events.html#event-pooling
    const isMac = window ? window.navigator.platform.indexOf('Mac') > -1 : false;
    const metaKey = event.metaKey; // eslint-disable-line
    const ctrlKey = keyEvent.ctrlKey; // eslint-disable-line
    const keyCode = keyEvent.keyCode; // eslint-disable-line
    const commandClicked = isMac && (metaKey || keyCode === 91);
    const ctrlClicked = !isMac && (ctrlKey || [17, 93, 224].indexOf(keyCode) > -1);
    if (commandClicked || ctrlClicked) {
      window.open(url, '_blank');
      return false;
    }
    push(url);
    if (callback) {
      callback();
    }
    return true;
  };

  static smoothScrollToTop = () => {
    window.scroll({
      behavior: 'smooth',
      top: 0
    });
  };

  static updateQueryParams = (path, params) => {

    const paramNames = params.map(p => p.paramName);

    const [pathname, query = ''] = path.split('?');
    const queryParams = query.split('&').filter(p => p);
    const updatedParams = [
      ...queryParams
      // remove existing params that are in new `params` array
        .filter((queryParam) => {
          const parts = queryParam.split('=');
          return paramNames.indexOf(parts[0]) === -1;
        }),
      // add supplied ones to string
      ...params
        .filter(p => p.paramValue)
        .map((param) => {
          return `${param.paramName}=${param.paramValue}`;
        })
    ].join('&');
    return pathname + '?' + updatedParams;

  };

  static getQueryParams = (queryString) => {
    if (queryString) {
      const params = (queryString.match(/(\w+)=([^&]+)/g) || [])
        .map((v) => {
          const p = v.split('=');
          return {
            [p[0]]: p[1]
          };
        })
        .reduce((acc, next) => {
          const key = Object.keys(next)[0];
          return {
            ...acc,
            [key]: next[key]
          };
        }, {});
      return {
        ...params
      };
    }
    return {};
  }
}

export class PEPHelpers {
  static getPersistantParams = (params) => {
    return {
      ...params,
      catStyle: 'ShowProducts',
      show: 'searchreport,metadata,skus,dimensions,templates,visualnavs,breadcrumbs'
    };
  };
}
